<script lang="ts">
    import MainLayout from '../#common/layout/Layout.svelte'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import {copyClipboard, delay} from "src/components/cabinet/#common/helpers"
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/clone'
    import editIcon from '@iconify/icons-fa-solid/pencil-alt'
    import saveIcon from '@iconify/icons-fa-solid/save'
    import questionIcon from '@iconify/icons-fa-solid/question-circle'
    import androidIcon from '@iconify/icons-fa-brands/android'
    import pcIcon from '@iconify/icons-fa-solid/desktop'
    import {showAlert} from "src/components/cabinet/#common/alert/store"
    import {api} from "src/services/api/reallis"
    import {userProfile} from 'src/services/auth'
    import {Link} from 'svelte-routing'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import {myNickname} from "src/components/cabinet/#services/myNickname"
    import {requestToDeleteAccount} from 'src/components/cabinet/#services/account'
    import {
        getSecretKey,
        enableTwoFactor,
        disableTwoFactor,
        isRequiredTwoFA,
        disableTwoFactorRequest,
    } from 'src/components/cabinet/#services/twoFactorAuthentication'
    import QrCode from 'svelte-qrcode'
    import {onMount} from "svelte";
    import {getAllSessions, logoutEverything} from 'src/components/main/#services/authJournal'

    let newsLetter: boolean
    let nickname
    let enableTwoFactorSending = false
    let disableTwoFactorSending = false
    let lostDeviceSending = false
    let nicknameSending = false
    let newsletterSending = false
    let loading = true
    let error
    let twoFaCode

    export let hash = null

    onMount(()=>{
        if (hash) {
            changeEmail()
        }
    })

    async function changeEmail()
    {
        try {
            await api.ws.ws1.request({
                data: {
                    agent: "auth",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "auth_changeMyEmail",
                    params: {
                        hash:hash
                    }
                }
            })
            await delay(500)
            update()
            showAlert.set({
                status: 'success',
                text: 'You have successfully changed your email'
            })
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: "Link has been expired"
            })
        }
    }

    function update() {
        myBalance.send()
        myNickname.reset()
        myNickname.send()
        api.ws.ws1.user.profileUpdate()
        .then(() => {
            loading = false
        })
        .catch(err => {
            error = err
        })
    }

    async function copy(event, value) {
        let button = event.currentTarget
        button.setAttribute('data-tooltip', 'Copied')
        copyClipboard(value)
        await delay(2500)
        button.removeAttribute('data-tooltip')
    }

    $: if (typeof nickname === "undefined") {
        nickname = $userProfile && $userProfile.nickname
    }

    async function changeNickname() {
        if (nickname.length < 4 || nickname.length > 30) {
            showAlert.set({
                status: 'error',
                text: 'Nickname must contain 4-30 characters'
            })
            return false
        }
        try {
            nicknameSending = true

            await api.ws.ws1.request({
                data: {
                    agent: "user",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "profile_changeNickname",
                    params: {
                        "newNickname": nickname
                    }
                }
            })

            showAlert.set({
                status: 'success',
                text: 'Nickname changed successfully'
            })
            update()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            nicknameSending = false
        }
    }

    $: newsLetter = $userProfile && $userProfile.isSubscribedToMailing

    async function changeNewsletter() {
        newsLetter = !newsLetter

        try {
            newsletterSending = true

            await api.ws.ws1.request({
                data: {
                    method:"profile_setMailingSubscriptionStatus",
                    agent:"user",
                    lang:"en",
                    auth:{
                        type: "webSite"
                    },
                    params: {
                        "status": newsLetter
                    }
                }
            })

            if (newsLetter) {
                showAlert.set({
                    status: 'success',
                    text: 'You have subscribed to the newsletter'
                })
            } else {
                showAlert.set({
                    status: 'success',
                    text: 'You have unsubscribed from the newsletter'
                })
            }
            update()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            window.scrollTo(0, 0)
            newsletterSending = false
        }
    }

    let date
    let deleteAccountSending = false
    let signOutSending = false
    let errorStatus = false
    let errorText = ''

    let token = api.ws.ws1.auth.session.accessToken

    async function init() {
        try {
            myNickname.send()
            isRequiredTwoFA.send()
            getAllSessions.send({ data: { page: 1, perPage: 8 } })
        } catch (err) {
            console.error(err)
        }
    }

    init()

    let TwoFactorEnableModalOpen = false
    let TwoFactorDisableModalOpen = false
    let deleteAccountModalOpen = false
    let activeSessionsModalOpen = false

    let uagent = navigator.userAgent.toLowerCase();
    let app2fa = 'https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai'
    if (uagent.search('iphone') > -1 || uagent.search('ipad') > -1) {
        app2fa = 'https://apps.apple.com/us/app/google-authenticator/id388497605'
    } else if (uagent.search('android') > -1) {
        app2fa = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
    }

    async function enableTwoFactorHandler() {
        if (twoFaCode) {
            try {
                enableTwoFactorSending = true

                await enableTwoFactor.request({data: {code: twoFaCode.toString()}})

                showAlert.set({
                    status: 'success',
                    text: '2FA has been successfully enabled'
                })
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            } finally {
                twoFaCode = ''
                enableTwoFactorSending = false
                TwoFactorEnableModalOpen = false
                window.scrollTo(0, 0)
                isRequiredTwoFA.reset()
                isRequiredTwoFA.send()
            }
        }
    }

    async function disableTwoFactorHandler() {
        try {
            disableTwoFactorSending = true
            await disableTwoFactor.request({ data: { code: twoFaCode.toString() } })

            showAlert.set({
                status: 'success',
                text: '2FA has been successfully disabled'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            twoFaCode = ''
            disableTwoFactorSending = false
            TwoFactorDisableModalOpen = false
            window.scrollTo(0, 0)
            isRequiredTwoFA.reset()
            isRequiredTwoFA.send()
        }
    }

    async function signOut() {
        try {
            signOutSending = true

            await logoutEverything.request()

            showAlert.set({
                status: 'success',
                text: 'You are logged out of all devices except this'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            activeSessionsModalOpen = false
            signOutSending = false
        }
    }

    async function deleteAccount() {
        try {
            deleteAccountSending = true
            errorStatus = false

            await requestToDeleteAccount.request()

            showAlert.set({
                status: 'success',
                text: 'We have sent an email confirming the deletion of the account'
            })
        } catch (err) {
            errorStatus = true;
            errorText = 'An Error Occurred, Please Try Again Later'
        } finally {
            deleteAccountModalOpen = false
            deleteAccountSending = false
            window.scrollTo(0, 0)
        }
    }

    async function lostDeviceHandler() {
        try {
            lostDeviceSending = true

            await disableTwoFactorRequest.request()

            showAlert.set({
                status: 'success',
                text: 'We have sent an email confirming the deletion of the 2FA'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            TwoFactorDisableModalOpen = false
            lostDeviceSending = false
        }
    }

    function openTwoFactorModal() {
        TwoFactorEnableModalOpen = true
        getSecretKey.send()
    }
</script>

<svelte:head>
    <title>Account setting</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper settings-wrapper">
            <Alert />
            <div class="page-title">Account setting</div>
            <div class="row">
                <div class="col-lg-10 col-xl-8 col-xxl-6 vertical-line pr-8">
                    <div class="page-subtitle">General setting</div>
                    <div class="form-group">
                        <label>Support <span class="notranslate">ID</span></label>
                        <div class="input-with-btn">
                            <input type="text" class="input w-100" value="{$userProfile?.userId}" readonly>
                            <button on:click={(e) => copy(e, $userProfile?.userId) } class="btn btn-second-big copy-btn btn-ml">
                                <IconifyIcon icon={copyIcon}/>
                            </button>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label for="settings-nickname">Nickname</label>
                        <div class="input-with-btn mb-2">
                            <div class="input-group">
                                <input type="text" id="settings-nickname" class="input w-100" required bind:value={nickname} placeholder="Enter Nickname">
                                <div class="input-group-append">
                                    <span class="input-group-text">#{$userProfile?.userId}</span>
                                </div>
                            </div>
                            <button class="btn btn-second-big btn-ml" class:loading={nicknameSending} on:click={changeNickname} disabled={nicknameSending}>
                                <span class="mobile-button-icon"><IconifyIcon icon={saveIcon}/></span>
                                <span class="pc-button-text">Change</span>
                            </button>
                        </div>
                        {#if $myNickname.loading}
                            <div class="field-note mb-2">Nickname change costs loading...</div>
                        {:else if $myNickname.value }
                            {#if +$myNickname.value === 0}
                                <div class="field-note mb-2">The first change of nickname is free</div>
                            {:else}
                                <div class="field-note mb-2">Nickname change costs <span class="notranslate">{$myNickname.value} DRAG</span></div>
                            {/if}
                        {:else}
                            <div class="field-note mb-2">An Error Occurred, Please Try Again Later</div>
                        {/if}
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Email</label>
                        <div class="input-with-btn mb-2">
                            <input type="text" class="input w-100" value="{$userProfile?.email}" readonly>
                            <!--
                            <Link to="settings/email" class="btn btn-primary settings-action">
                                <span class="mobile-button-icon"><IconifyIcon icon={editIcon}/></span>
                                <span class="pc-button-text">Change</span>
                            </Link>
                            -->
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Password</label>
                        <div class="input-with-btn mb-2">
                            <input type="password" class="input w-100" value="**********" readonly disabled>
                            {#if $userProfile?.hasPassword}
                                <Link to="settings/password-change" class="btn btn-second-big btn-ml change-password-btn">
                                    <span class="mobile-button-icon"><IconifyIcon icon={editIcon}/></span>
                                    <span class="pc-button-text">Change</span>
                                </Link>
                            {:else}
                                <Link to="settings/password-set" class="btn btn-second-big btn-ml change-password-btn">
                                    <span class="mobile-button-icon"><IconifyIcon icon={editIcon}/></span>
                                    <span class="pc-button-text">Set</span>
                                </Link>
                            {/if}
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label class="mb-0">Login history</label>
                        <div class="field-note mb-3">Sign out of your account on all devices except this one</div>
                        <div class="buttons-group">
                            <button class="btn btn-primary" class:loading={signOutSending} on:click={signOut} disabled={signOutSending}><span>End all other sessions</span></button>
                            <button class="btn btn-second-big" on:click={() => { activeSessionsModalOpen = true }}>Login history</button>
                        </div>
                        <Modal bind:visible={activeSessionsModalOpen}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Login history</div>
                                <div class="modal-custom__text">
                                    {#if $getAllSessions.hasValue && $getAllSessions.value?.journal}
                                        {#each $getAllSessions.value.journal as {appId, ipAddress, country, authDate}}
                                            <div class="device">
                                                <div class="device__icon">
                                                    {#if appId}
                                                        <IconifyIcon icon={androidIcon}/>
                                                    {:else}
                                                        <IconifyIcon icon={pcIcon}/>
                                                    {/if}
                                                </div>
                                                <div class="device__text">
                                                    <div class="device__text-ip">
                                                        {ipAddress}
                                                        {#if country}
                                                            <img src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{country}.svg" class="country-flag" alt="">
                                                        {/if}
                                                    </div>
                                                    <div class="device__text-date">{new Date(authDate).toLocaleString()}</div>
                                                </div>
                                            </div>
                                        {/each}
                                    {:else if $getAllSessions.loading}
                                        Loading...
                                    {:else}
                                        An Error Occurred, Please Try Again Later
                                    {/if}
                                </div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { activeSessionsModalOpen = false }}>Close</button>
                                </div>
                            </svelte:fragment>
                        </Modal>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label class="mb-3">Two-factor authentication
                            <a href="{app2fa}" target="_blank" on:click|stopPropagation={() => {}}>
                                <IconifyIcon icon={questionIcon} class="info-icon"/>
                            </a>
                        </label>
                        <div class="field-note mb-3">Two-Factor Authentication (2FA) can be used to help protect your account from unauthorized access by requiring you to enter security code when you sign in.</div>
                        {#if $isRequiredTwoFA.loading}
                            Loading...
                        {:else if $isRequiredTwoFA.hasValue }
                            {#if $isRequiredTwoFA.value}
                                <button class="btn btn-primary" on:click={() => TwoFactorDisableModalOpen = true}><span>Disable 2FA</span></button>
                            {:else}
                                <button class="btn btn-primary" on:click={openTwoFactorModal}><span>Enable 2FA</span></button>
                            {/if}
                        {:else}
                            An Error Occurred, Please Try Again Later
                        {/if}
                        <Modal bind:visible={TwoFactorEnableModalOpen}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Two-factor authentication</div>
                                <div class="modal-custom__text">
                                    Scan the QR code or enter the key manually.<br><br>
                                    <div class="mb-3">
                                        <div class="break-all">
                                            <strong>Key</strong>:
                                            {#if $getSecretKey.loading}
                                                Loading...
                                            {:else if $getSecretKey.hasValue && $getSecretKey.value.secret}
                                                {$getSecretKey.value.secret}
                                            {:else}
                                                An Error Occurred, Please Try Again Later
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="text-center mb-3">
                                        <div class="qr-code-wrapper">
                                            {#if $getSecretKey.loading}
                                                Loading...
                                            {:else if $getSecretKey.hasValue && $getSecretKey.value.secret}
                                                <QrCode value="otpauth://totp/Realis.network?secret={$getSecretKey.value.secret}&issuer={$userProfile?.email}" background="#ffffff" color="#27272F" size="200"/>
                                            {:else}
                                                An Error Occurred
                                            {/if}
                                        </div>
                                    </div>
                                    <input type="text" class="form-control qr-code-field" bind:value={twoFaCode} placeholder="Enter 2FA code">
                                </div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { TwoFactorEnableModalOpen = false }}>Cancel</button>
                                    <button class="btn btn-primary" class:loading={enableTwoFactorSending} on:click={enableTwoFactorHandler} disabled={enableTwoFactorSending || !$getSecretKey.hasValue}><span>Activate</span></button>
                                </div>
                            </svelte:fragment>
                        </Modal>
                        <Modal bind:visible={TwoFactorDisableModalOpen}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Two-factor authentication</div>
                                <div class="modal-custom__text">
                                    To disable 2FA, enter the confirmation code.<br><br>
                                    <input type="text" class="form-control qr-code-field" bind:value={twoFaCode} placeholder="Enter 2FA code">
                                    <div class="text-center">
                                        <button class="btn lost-device-btn" class:loading={lostDeviceSending} on:click={lostDeviceHandler} disabled={lostDeviceSending}>Lost your authentication device?</button>
                                    </div>
                                </div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { TwoFactorDisableModalOpen = false }}>Cancel</button>
                                    <button class="btn btn-primary" class:loading={disableTwoFactorSending} on:click={disableTwoFactorHandler} disabled={disableTwoFactorSending}><span>Disable</span></button>
                                </div>
                            </svelte:fragment>
                        </Modal>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Receive the newsletter?</label>
                        <label class="checkbox">
                            <input type="checkbox" class="form-check-input" checked={newsLetter} on:change={changeNewsletter}>Get our latest news
                        </label>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label class="mb-3">Deletion of personal data</label>
                        <button class="btn btn-primary" on:click={() => { deleteAccountModalOpen = true }}><span>Delete account</span></button>
                        <Modal bind:visible={deleteAccountModalOpen}>
                            <svelte:fragment slot="content">
                                <div class="modal-custom__title">Deletion of personal data</div>
                                <div class="modal-custom__text">We will send you an confirmation email. After confirmation, all your data will be deleted.<br><br>Are you sure you want to delete your account and all data?</div>
                                <div class="modal-custom__footer">
                                    <button class="btn btn-cancel" on:click={() => { deleteAccountModalOpen = false }}>Cancel</button>
                                    <button class="btn btn-primary" class:loading={deleteAccountSending} on:click={deleteAccount} disabled={deleteAccountSending}><span>Yes</span></button>
                                </div>
                            </svelte:fragment>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .settings-wrapper :global(.form-control) {
        color: #848586;
        padding: 12px 24px;
    }

    .form-group .input-group .form-control {
        border-right: 0;
    }

    .input-group-append .input-group-text {
        transition: .25s;
    }

    .pr-8 {
        padding-right: 80px;
    }

    .lost-device-btn {
        background: none !important;
        border: 0;
        color: #afb1b3;
        font-size: 15px;
        margin: 15px 0 0;
        transition: .25s;
        box-shadow: none !important;
    }

    .lost-device-btn:hover {
        color: #cfd1d2;
    }

    .form-check-input {
        margin: 2px 10px 0 0;
    }

    .form-group .input-group .form-control:not([readonly]):focus ~ .input-group-append .input-group-text {
        border-color: #FF5D1C;
    }

    .checkbox {
        display: table;
        font-weight: 400 !important;
        cursor: pointer;
    }

    .settings-wrapper :global(.form-control[readonly]:focus) {
        box-shadow: inset 0 0 0 2px #525252;
    }

    .form-group .form-control[readonly] {
        background: #585F67;
    }

    .input-group {
        flex-wrap: nowrap;
    }

    .cabinet-wrapper :global(.btn:before) {
        display: none !important;
    }

    .mobile-button-icon {
        display: none;
    }

    .settings-wrapper :global(label) {
        display: block;
        margin-bottom: .5rem;
        font-size: 18px;
    }

    .settings-wrapper :global(.input-group) {
        flex-wrap: nowrap;
    }

    .settings-wrapper :global(.checkbox input) {
        margin-right: 10px;
        font-size: 20px;
        margin-top: 4px;
        position: relative;
        cursor: pointer;
    }

    .form-group .field-note {
        color: #c9c7c7;
        font-size: 16px;
        line-height: normal;
        margin-top: 5px;
    }

    .settings-wrapper :global(.item svg) {
        vertical-align: top;
        margin: 0 12px 0 0;
        color: #FF5D1C;
    }

    .settings-wrapper :global(.checkbox) {
        font-size: 17px;
        line-height: 30px;
    }

    .input-with-btn {
        display: flex;
    }

    .input-with-btn :global(.btn.btn-primary) {
        padding: 16px 20px;
        vertical-align: top;
        height: 50px;
        margin-left: 15px;
        white-space: nowrap;
        min-width: auto;
        border-radius: 10px;
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        background: #353064;
    }

    .form-group .btn-primary {
        font-family: 'Inter', sans-serif;
    }

    .setting-loading {
        height: 44px;
        width: 350px;
        box-shadow: inset 0 0 0 2px #525252;
    }

    .input-group-text {
        line-height: normal;
        border: 1px solid #57548A;
        border-radius: 0 6px 6px 0;
        margin-bottom: 0;
        padding: 15px 25px;
        vertical-align: top;
        height: 50px;
        background: #343168;
        border-left: 0;
        color: #c8cbcd;
        text-align: left;
    }

    :global(.info-icon) {
        font-size: 22px;
        vertical-align: top;
        margin: -2px 0 0 6px;
        color: white;
    }

    .active-sessions-btn {
        padding: 11px 45px 11px !important;
        font-weight: 400 !important;
    }

    .device {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #3b405e;
        padding: 5px 0;
    }

    .device:last-child {
        border-bottom: 0;
    }

    .device__icon {
        width: 50px;
        height: 50px;
        margin-right: 10px;
        font-size: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #a0aab7;
    }

    .device__text-ip {
        font-size: 16px;
        line-height: normal;
        font-weight: 500;
        padding: 2px 0 0 0;
    }

    .country-flag {
        display: inline-block;
        width: 20px;
        vertical-align: top;
        margin: 2px 0 0 6px;
        border-radius: 2px;
    }

    .device__text-date {
        font-size: 14px;
        color: #a0aab7;
    }

    .form-group label {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 500;
    }

    .form-group .form-control {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
    }

    .form-group .form-control:focus {
        border-color: #FF5D1C;
        box-shadow: none;
    }

    .form-group .form-control[readonly]:focus {
        border-color: #CAD5E0;
    }

    .qr-code-field {
        max-width: 200px;
        margin: 0 auto;
        text-align: center;
    }

    .break-all {
        word-break: break-all;
    }

    .qr-code-wrapper {
        width: 200px;
        height: 200px;
        background: white;
        border-radius: 6px;
        margin: 0 auto;
        color: #01070A;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .buttons-group button.btn {
        margin: 10px 10px 0 0 !important;
    }

    .btn-second-big.copy-btn {
        padding: 16px;
    }

    :global(.btn-second-big.btn-ml) {
        margin-left: 16px;
    }

    @media(max-width: 1299px) {
        .pr-8 {
            padding-right: 50px;
        }
    }

    @media(max-width: 991px) {
        .cabinet-wrapper .vertical-line:after {
            display: none;
        }

        .pr-8 {
            padding-right: 12px;
        }

        .active-sessions-btn {
            padding: 9px 25px !important;
        }
    }

    @media(max-width: 767px) {
        :global(.app .settings-wrapper .btn-second-big.change-password-btn) {
            padding: 12px;
            border-radius: 6px;
            margin-left: 12px;
            min-width: 40px;
        }

        .setting-loading {
            width: 100%;
        }

        .pc-button-text {
            display: none;
        }

        .mobile-button-icon {
            display: inline-block;
        }

        .settings-wrapper :global(.item svg) {
            margin: 5px 0 0 0;
        }

        .settings-wrapper :global(.form-control) {
            width: 100%;
        }

        .settings-wrapper :global(.checkbox) {
            font-size: 15px;
        }

        .settings-wrapper :global(label) {
            font-size: 16px;
        }

        .settings-wrapper :global(.form-control) {
            max-width: 100%;
        }

        .settings-wrapper :global(.btn) {
            font-size: 14px !important;
            font-weight: 500;
        }

        #settings-nickname {
            margin-bottom: 0;
        }

        .btn-primary.copy-btn {
            padding: 12px 17px;
        }

        .settings-wrapper :global(.btn.settings-action) {
            height: 40px;
            min-width: 40px;
            padding: 10px 12px;
            margin-left: 13px;
        }

        .form-control.field {
            padding: 10px;
            font-size: 16px;
            height: 40px;
        }

        .input-group-text {
            height: 40px;
            font-size: 12px;
            padding: 10px;
        }

        .input-with-btn {
            justify-content: space-between;
        }

        .form-group .field-note {
            font-size: 14px;
        }

        .settings-wrapper .checkbox {
            font-size: 15px;
            line-height: normal;
            padding-left: 35px;
        }

        .settings-wrapper .checkbox input {
            margin-left: -32px;
            margin-top: 0;
        }

        .device__icon {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            font-size: 24px;
        }

        .device__text-ip {
            font-size: 14px;
            padding: 2px 0;
        }

        .device__text-date {
            font-size: 12px;
        }

        :global(.info-icon) {
            font-size: 20px;
            margin: 0 0 0 6px;
        }

        .active-sessions-btn {
            padding: 11px 22px !important;
            font-weight: 500 !important;
        }

        .input-with-btn .btn {
            padding: 12px;
            border-radius: 6px;
            margin-left: 12px;
            min-width: 40px;
        }
    }
</style>
